// @flow

import React, { useEffect } from 'react';
import RModal from 'react-modal';
import classnames from 'classnames';
import { P } from 'components';
import { useSelector } from 'react-redux';
import { ReactComponent as Cross } from 'assets/icons/cross.svg';
import styles from './styles.module.scss';

type Props = {
  title?: string,
  children?: any,
  onClose?: () => void,
  isOpen: boolean,
  className?: string,
  style?: { [any]: any },
  closeMs?: number,
};

const Modal = (
  {
    title = '',
    children = null,
    onClose = () => {},
    isOpen,
    className,
    closeMs = 0,
    style,
  }: Props,
) => {
  const tutorialItemName = useSelector((state) => state.tutorial.name);

  useEffect(() => {
    if (tutorialItemName === 'seeRangeModal') return;
    if (isOpen && closeMs > 0) {
      setTimeout(() => onClose(), closeMs);
    }
  }, [isOpen]);

  return (
    <RModal
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      isOpen={isOpen}
      className={classnames(styles.modal, className)}
      overlayClassName={classnames(styles.overlay)}
      ariaHideApp={false}
      onRequestClose={() => {
        if (tutorialItemName === 'seeRangeModal') return;
        onClose();
      }}
    >
      <button className={styles.buttonClose} type="button" onClick={onClose}>
        <Cross className={styles.cross} />
      </button>
      {title && <P>{title}</P>}
      <div className={styles.modalContent} style={style}>
        {children}
      </div>
    </RModal>
  );
};

export default Modal;
